var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import store from "@redux/store";
import React, { useEffect, useRef, useState } from "react";
export var StoreContext = React.createContext(store);
export var useCustomSelector = function (selector, equalityFn) {
    // const store = useContext(StoreContext);
    // if (!store) {
    //   throw new Error("Store not found in context");
    // }
    // const selectedState = useMemo(() => {
    //   const state = store.;
    //   return selector(state);
    // }, [selector, store, equalityFn]);
    // return selectedState;
    var _a = __read(useState(selector(store.getState())), 2), currentSelectedState = _a[0], setCurrentSelectedState = _a[1];
    var prevSelectedStateRef = useRef(currentSelectedState);
    useEffect(function () {
        var unsubscribe = store.subscribe(function () {
            var nextSelectedState = selector(store.getState());
            if (equalityFn &&
                equalityFn(prevSelectedStateRef.current, nextSelectedState)) {
                prevSelectedStateRef.current = currentSelectedState;
                setCurrentSelectedState(nextSelectedState);
            }
            else {
                setCurrentSelectedState(nextSelectedState);
            }
        });
        return function () {
            unsubscribe();
        };
    }, [selector]);
    // const prevSelectedState = prevSelectedStateRef.current;
    return currentSelectedState;
};
